import { render } from "./ComboBoxControl.vue?vue&type=template&id=816bad24&scoped=true"
import script from "./ComboBoxControl.vue?vue&type=script&lang=js"
export * from "./ComboBoxControl.vue?vue&type=script&lang=js"

import "./ComboBoxControl.vue?vue&type=style&index=0&id=816bad24&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816bad24"]])

export default __exports__